/**
 * Replies with the plain text of a select option label or value.
 *
 * Option labels reach the builder both as plain text (field labels, calculation
 * names) and already HTML-escaped (esc_html__() config labels). Decoding once
 * lets every option template escape the result without double-encoding, so no
 * label or value can create markup in the builder.
 *
 * @package Ninja Forms builder
 * @subpackage Main App
 * @since 3.15.7
 * @see https://github.com/Saturday-Drive/ninja-forms/issues/8258
 */
define( 'controllers/app/optionText',[], function() {
    /**
     * A textarea's content is parsed as text only, so entities are decoded
     * without creating elements or loading resources.
     */
    var decode = function( text ) {
        if ( null == text ) {
            return '';
        }

        var textarea = document.createElement( 'textarea' );
        textarea.innerHTML = String( text );

        return textarea.value;
    };

    var controller = Marionette.Object.extend( {
        initialize: function() {
            // Radio calls a reply handler and returns its result, so hand back the function itself.
            nfRadio.channel( 'app' ).reply( 'get:optionText', function() {
                return decode;
            } );
        }
    } );

    return controller;
} );

